import React from "react";
import logo from "../../../img/logo.png";
import "./heartest.css";
import { Link } from "react-router-dom";

export default function NavHear() {
  const logout = () => {
    // localStorage.removeItem("access_token");
    // localStorage.removeItem("UserName");
    // localStorage.removeItem("lastName");
    localStorage.removeItem("step2");
    localStorage.removeItem("step3");
    localStorage.removeItem("step4");
    localStorage.removeItem("step5");
    localStorage.removeItem("step6");
    localStorage.removeItem("step7");
    localStorage.removeItem("step8");
    localStorage.removeItem("step9");
    localStorage.removeItem("Rightear2KHz");
    localStorage.removeItem("Rightear4KHz");
    localStorage.removeItem("Leftear1KHz");
    localStorage.removeItem("Leftear6KHz");
    localStorage.removeItem("Measuretest");
    localStorage.removeItem("result_test_id");
    localStorage.removeItem("Rightear500Hz");
    localStorage.removeItem("rightear1KHz");
    localStorage.removeItem("Leftear500Hz");
    localStorage.removeItem("Leftear2000KHz");
    // history("/");
  };
  return (
    <div>
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src={logo} onClick={logout} className="img-fluid" alt="logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav align-items-center">
              <li className="nav-item">
                <Link
                  className="nav-link"
                  onClick={logout}
                  aria-current="page"
                  to="/"
                >
                  Home
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}
